import { createContext, useContext, ReactNode } from "react";
import globalStore from "./index";

// Create context for store injection
const StoreContext = createContext(globalStore);

/**
 * Provider that allows overriding the global store
 * Used for adapting external stores (e.g., from Rapid app) to work with main app components
 */
export function StoreProvider({
    store = globalStore,
    children
}: {
    store?: typeof globalStore;
    children: ReactNode;
}) {
    return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
}

/**
 * Hook to access the current store (either global or overridden)
 * Use this instead of directly importing globalStore for components that need to be adaptable
 */
export function useGlobalStore() {
    return useContext(StoreContext);
}
